export default class ProfileApi {
    /**
     * Find all instances of the model matched by filter from the data source
     *
     * @param filter
     * @returns {Object}
     */
    static find(filter) {
        return axios => axios.get('/profiles', { filter });
    }
}



// WEBPACK FOOTER //
// ./src/api/profile.js